import React, { createContext, useState } from "react";

export const StoreContext = createContext();

const Store = ({ children }) => {
  const [showPdfLinkView, setShowPdfLinkView] = useState({
    range: null,
    show: false,
  });
  const [isSidebarActive, setIsSidebarActive] = useState(true);
  const [isRoughan, setisRoughan] = useState(0);


  const value = {
    showPdfLinkView,
    setShowPdfLinkView,

    isSidebarActive, 
    setIsSidebarActive,

    isRoughan, setisRoughan
  };

  return (
    <StoreContext.Provider value={value}>{children}</StoreContext.Provider>
  );
};

export default Store;
